import Icon from 'ui/Icon';
import Menu from 'ui/Menu';

import { useSankeyFormContext } from '../../../contexts/sankeyFormContext';
import { useCorporateBrandingContext } from '../../../utils/team';
import { useCurrentUser } from '../../../utils/user';
import ActionMenuTriggerButton from '../ActionMenuTriggerButton';
import TrackedMenuItem from '../TrackedMenuItem';
import MenuCheckbox from './MenuCheckbox';

const ViewMenu: React.FC = () => {
  const { openCorporateBrandingDrawer } = useCorporateBrandingContext();
  const { form, isFetching, isReadOnly } = useSankeyFormContext();
  const { user } = useCurrentUser();

  const showLabels = form.watch('show_labels');

  return (
    <Menu.Root>
      <Menu.Trigger>
        <ActionMenuTriggerButton disabled={isFetching || isReadOnly}>
          View
        </ActionMenuTriggerButton>
      </Menu.Trigger>
      <Menu.Content>
        <TrackedMenuItem
          value="corporate-branding"
          onClick={openCorporateBrandingDrawer}
        >
          <Icon color="gray.700" icon="palette" /> Corporate branding
        </TrackedMenuItem>
        <Menu.Separator />
        <MenuCheckbox field="show_title" label="Show diagram title" />
        <MenuCheckbox field="show_labels" label="Show diagram labels" />
        <MenuCheckbox
          field="show_comparison_line"
          label="Show comparison line"
          disabled={!showLabels}
          disabledTooltip="Comparison line can only be shown when labels are enabled"
        />
        <MenuCheckbox
          field="show_watermark"
          label="Show watermark"
          disabled={!user?.has_active_subscription}
          disabledTooltip="Removing the watermark requires a subscription"
        />
        <Menu.Separator />
        <MenuCheckbox field="show_data_editor" label="Show data editor" />
        <MenuCheckbox field="show_imbalances" label="Show node imbalances" />
        <MenuCheckbox
          field="show_canvas_resolution"
          label="Show canvas resolution"
        />
      </Menu.Content>
    </Menu.Root>
  );
};

export default ViewMenu;
